// Common — route BE thật: GET /api/Common/GetSystemKey?key=<parentCodeKey|all>
export const apiGetSystemKey = '/api/Common/GetSystemKey'
